import Api from 'utils/api'

export const fetchTemplate = ({
  project,
  uuid,
}: {
  project?: string | number
  uuid?: string
}) => Api.get(['templates', uuid], { project })

export const fetchTemplateWorkspace = ({
  talent_assessment_workspace,
  uuid,
}: {
  talent_assessment_workspace: string | number
  uuid?: string
}) => Api.get(['templates', uuid], { talent_assessment_workspace })
